import { render, staticRenderFns } from "./MultimediaTabs.vue?vue&type=template&id=0b01d05a&"
import script from "./MultimediaTabs.vue?vue&type=script&lang=js&"
export * from "./MultimediaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports